import React, { useEffect, useRef, useState } from "react";
import { useNavigate } from "react-router-dom";
import { Loader2 } from "lucide-react";
import api from "../lib/api";
import { useAuth } from "../context/AuthContext";

export default function AuthCallback() {
  const navigate = useNavigate();
  const { setUser } = useAuth();
  const processed = useRef(false);
  const [error, setError] = useState("");

  useEffect(() => {
    if (processed.current) return;
    processed.current = true;

    const hash = window.location.hash || "";
    const match = hash.match(/session_id=([^&]+)/);
    const sessionId = match ? decodeURIComponent(match[1]) : null;

    if (!sessionId) {
      navigate("/login");
      return;
    }

    (async () => {
      try {
        const res = await api.post("/auth/session", { session_id: sessionId });
        setUser({ ...res.data, is_admin: true });
        window.history.replaceState({}, document.title, "/admin");
        navigate("/admin", { replace: true, state: { user: res.data } });
      } catch (e) {
        const msg = e?.response?.data?.detail || "Sign-in failed. Please try again.";
        setError(msg);
      }
    })();
  }, [navigate, setUser]);

  return (
    <div className="min-h-screen grid place-items-center bg-ink px-6">
      <div className="text-center">
        {error ? (
          <>
            <p className="text-white text-lg font-display">{error}</p>
            <button
              onClick={() => (window.location.href = "/login")}
              className="mt-5 rounded-full bg-gold px-6 h-11 font-semibold text-ink"
            >
              Back to login
            </button>
          </>
        ) : (
          <>
            <Loader2 className="mx-auto animate-spin text-gold" size={40} />
            <p className="mt-4 text-white/70">Signing you in…</p>
          </>
        )}
      </div>
    </div>
  );
}
